import React, { useEffect, useState } from 'react';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { validateInviteLink } from 'src/app/api/AgentsApi';

interface IProps {
  children: React.ReactNode;
}

function AgentLeadWrapper({ children }: IProps) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    const check = async () => {
      const token = searchParams.get('token');

      if (!token) return navigate('/');

      // const isUrlValid = await validateInviteLink(token);
      // if (!isUrlValid.data.data.valid) return navigate('/');

      setLoading(false);
    };
    check();
  }, []);

  if (loading) return <FuseSplashScreen />;

  return children;
}

export default AgentLeadWrapper;
